import { put, call, all, fork, takeEvery } from "redux-saga/effects";
import * as SuccessActions from "../actionTypes/successActionTypes";
import * as SuccessActionCreators from "../actionCreators/successActionCreators"
import { arcApprove } from "../services/APIservice";
import { getTransactionIdFromURL, getValueFromLocalStorage, replaceValueFromLocalStorage } from "../../constants/utils";
import { ARGO_SUCCESS, AUTH_KEY, NOT_AUTHORIZED_ERROR } from "../../constants/constants";


function* onSubmitArcApproval() {
  try {
    let txnId = getTransactionIdFromURL();
    yield put(SuccessActionCreators.submitARCApproveRequest())
    let authKey = getValueFromLocalStorage(AUTH_KEY(txnId))
    if (authKey === null) {
      throw NOT_AUTHORIZED_ERROR
    }
    const { data, headers } = yield call(arcApprove);
    const { authorization } = headers;
    if (authorization !== null || authorization !== undefined) {
      replaceValueFromLocalStorage(AUTH_KEY(txnId), authorization)
    }
    if (data.code === ARGO_SUCCESS) {
      yield put(SuccessActionCreators.submitARCApproveSuccess(data.data));
    } else {
      throw data
    }
  } catch (error) {
    if (error?.response?.data.status === NOT_AUTHORIZED_ERROR.code) {
      yield put(SuccessActionCreators.submitARCApproveFailure(NOT_AUTHORIZED_ERROR))
    } else {
      yield put(SuccessActionCreators.submitARCApproveFailure(error))
    }
  }
}

function* watchOnSubmitArcApproval() {
  yield takeEvery(SuccessActions.SUBMIT_ARC_APPROVE, onSubmitArcApproval)
}

export default function* SuccessSaga() {
  yield all([fork(watchOnSubmitArcApproval)])
}